<angular-loader></angular-loader>
<div dir="rtl" style="height: 100%; overflow: hidden;">
    <router-outlet></router-outlet>
</div>
    



